<template lang="pug">
form(@submit.prevent="onFilter")
  .columns.align-center
    .column.col-auto(
      v-if="isEnabledFilter('created_at_gteq') || initializePeriodo"
    )
      .pb-1
        small {{ filters.created_at_gteq }}
        datepicker(
          v-model="q.created_at_gteq",
          :placeholder="filters.created_at_gteq",
          input-class="form-input input-sm"
        )
    .column.col-auto(
      v-if="isEnabledFilter('created_at_lteq') || initializePeriodo"
    )
      .pb-1
        small {{ filters.created_at_lteq }}
        datepicker(
          v-model="q.created_at_lteq",
          :placeholder="filters.created_at_lteq",
          full-day,
          input-class="form-input input-sm"
        )
    .column.col-auto(v-if="isEnabledFilter('modelo_id_eq')")
      .pb-1
        small {{ filters.modelo_id_eq }}
        doc-modelo-picker(v-model="q.modelo_id_eq", sm)
    .column.col-auto(v-if="isEnabledFilter('ciencia_em_gteq')")
      .pb-1
        small {{ filters.ciencia_em_gteq }}
        datepicker(
          v-model="q.ciencia_em_gteq",
          :placeholder="filters.ciencia_em_gteq",
          input-class="form-input input-sm"
        )
    .column.col-auto(v-if="isEnabledFilter('ciencia_em_lteq')")
      .pb-1
        small {{ filters.ciencia_em_lteq }}
        datepicker(
          v-model="q.ciencia_em_lteq",
          :placeholder="filters.ciencia_em_lteq",
          input-class="form-input input-sm",
          full-day
        )
    .column.col-auto(v-if="isEnabledFilter('autuado_em_gteq')")
      .pb-1
        small {{ filters.autuado_em_gteq }}
        datepicker(
          v-model="q.autuado_em_gteq",
          :placeholder="filters.autuado_em_gteq",
          input-class="form-input input-sm"
        )
    .column.col-auto(v-if="isEnabledFilter('autuado_em_lteq')")
      .pb-1
        small {{ filters.autuado_em_lteq }}
        datepicker(
          v-model="q.autuado_em_lteq",
          :placeholder="filters.autuado_em_lteq",
          full-day,
          input-class="form-input input-sm"
        )
    .column.col-auto(v-if="isEnabledFilter('debito_vence_em_gteq')")
      .pb-1
        small {{ filters.debito_vence_em_gteq }}
        datepicker(
          v-model="q.debito_vence_em_gteq",
          :placeholder="filters.debito_vence_em_gteq",
          input-class="form-input input-sm"
        )
    .column.col-auto(v-if="isEnabledFilter('debito_vence_em_lteq')")
      .pb-1
        small {{ filters.debito_vence_em_lteq }}
        datepicker(
          v-model="q.debito_vence_em_lteq",
          :placeholder="filters.debito_vence_em_gteq",
          full-day,
          input-class="form-input input-sm"
        )
    .column.col-auto(v-if="isEnabledFilter('debito_vencido')")
      .pb-1
        small {{ filters.debito_vencido }}
        select.form-select.select-sm(v-model="debitoVencido")
          option(value="*-*") todos
          option(value="1-*") todos vencidos
          option(value="1-10") até 10 dias
          option(value="11-20") de 11 a 20 dias
          option(value="16-30") de 15 a 30 dias
          option(value="31-45") de 31 a 45 dias
          option(value="46-60") de 46 a 60 dias
          option(value="61-90") de 61 a 90 dias
          option(value="91-*") acima de 90 dias
    .column.col-auto(v-if="isEnabledFilter('updated_at_gteq')")
      .pb-1
        small {{ filters.updated_at_gteq }}
        datepicker(
          v-model="q.updated_at_gteq",
          :placeholder="filters.updated_at_gteq",
          input-class="form-input input-sm"
        )
    .column.col-auto(v-if="isEnabledFilter('updated_at_lteq')")
      .pb-1
        small {{ filters.updated_at_lteq }}
        datepicker(
          v-model="q.updated_at_lteq",
          :placeholder="filters.updated_at_lteq",
          full-day,
          input-class="form-input input-sm"
        )
    .column.col-auto(v-if="isEnabledFilter('regularizar_em_vencimento')")
      .pb-1
        small {{ filters.regularizar_em_vencimento }}
        select.form-select.select-sm(v-model="regularizar_em_vencimento")
          option(value="") Todos
          option(value="vencido") Vencido
          option(value="a_vencer") À vencer
    .column.col-auto(v-if="isEnabledFilter('situacao_id_eq')")
      .pb-1
        small {{ filters.situacao_id_eq }}
        doc-situacao-picker(v-model="q.situacao_id_eq", sm)
    .column.col-auto(v-if="isEnabledFilter('comentario_situacao_id_eq')")
      .pb-1
        small {{ filters.comentario_situacao_id_eq }}
        comentario-situacao-picker(v-model="q.comentario_situacao_id_eq", sm)
    .column.col-auto(v-if="isEnabledFilter('existe_senha_web_eq')")
      .pb-1
        small {{ filters.existe_senha_web_eq }}
        select.form-select.select-sm(v-model="q.existe_senha_web_eq")
          option(:value="undefined") Todos
          option(:value="true") Sim
          option(:value="false") Não
    .column.col-auto(v-if="isEnabledFilter('fiscal_id_eq')")
      .pb-1
        small {{ filters.fiscal_id_eq }}
        fiscal-picker(v-model="q.fiscal_id_eq", sm)
    .column.col-auto(v-if="isEnabledFilter('cadastro_zona_eq')")
      .pb-1
        small {{ filters.cadastro_zona_eq }}
        input.form-input.input-sm(
          type="tel",
          :placeholder="filters.cadastro_zona_eq",
          v-model="q.cadastro_zona_eq"
        )
    .column.col-auto(v-if="isEnabledFilter('cadastro_quadra_eq')")
      .pb-1
        small {{ filters.cadastro_quadra_eq }}
        input.form-input.input-sm(
          type="tel",
          :placeholder="filters.cadastro_quadra_eq",
          v-model="q.cadastro_quadra_eq"
        )
    .column.col-auto(v-if="isEnabledFilter('cadastro_lote_eq')")
      .pb-1
        small {{ filters.cadastro_lote_eq }}
        input.form-input.input-sm(
          type="tel",
          :placeholder="filters.cadastro_lote_eq",
          v-model="q.cadastro_lote_eq"
        )
    .column.col-auto(v-if="isEnabledFilter('reincidente_eq')")
      .pb-1
        small {{ filters.reincidente_eq }}
        int.form-input.input-sm(
          :placeholder="filters.reincidente_eq",
          v-model="q.reincidente_eq"
        )
    .column.col-auto(v-if="isEnabledFilter('ano_eq')")
      .pb-1
        small {{ filters.ano_eq }}
        year.form-input.input-sm(
          :placeholder="filters.ano_eq",
          v-model="q.ano_eq"
        )
    .column.col-auto(v-if="isEnabledFilter('tipo_eq')")
      .pb-1
        small {{ filters.tipo_eq }}
        doc-tipo-select.form-select.select-sm(v-model="q.tipo_eq")
    .column.col-auto(v-if="isEnabledFilter('tipo_entrega_eq')")
      .pb-1
        small {{ filters.tipo_entrega_eq }}
        select-doc-ciencia-tipo.form-select.select-sm(
          v-model="q.tipo_entrega_eq"
        )
    .column.col-auto(v-if="isEnabledFilter('fiscal_usuario_grupo_id_in')")
      .pb-1
        small {{ filters.fiscal_usuario_grupo_id_in }}
        usuario-grupos-picker(v-model="q.fiscal_usuario_grupo_id_in", sm)
    .column.col-auto(v-if="isEnabledFilter('irregularidades_descricao_cont')")
      .pb-1
        small {{ filters.irregularidades_descricao_cont }}
        input.form-input.input-sm(v-model="q.irregularidades_descricao_cont")
    .column.col-auto.mt-2.pt-2.no-print
      button.mt-2.btn.btn-action.s-circle.btn-sm(type="submit")
        i.fa.fa-filter
      a.mt-2.ml-2.btn.btn-action.s-circle.btn-sm.no-print(
        onclick="window.print()"
      )
        i.fa.fa-print
    .column.col-auto.mt-2.pt-2.no-print
      enabled-filters.mt-1(
        :localStorageKey="filterKey",
        :defaultEnabledFilters="defaultEnabledFilters",
        :enabledFilters="enabledFilters",
        :filters="filters",
        :query="q",
        :setEnabledFilters="setEnabledFilters"
      )
</template>

<script>
import filterMixin from "@/mixins/filter"

export default {
  mixins: [filterMixin],
  props: {
    filterKey: { type: String, default: "doc-indicadores-filters" },
    initializePeriodo: { type: Boolean, default: false },
  },
  data() {
    return {
      filters: {
        created_at_gteq: "Emissão início",
        created_at_lteq: "Emissão fim",
        modelo_id_eq: "Modelo",
        ciencia_em_gteq: "Ciência início",
        ciencia_em_lteq: "Ciência fim",
        autuado_em_gteq: "Autuação início",
        autuado_em_lteq: "Autuação fim",
        debito_vence_em_gteq: "Vcto débito início",
        debito_vence_em_lteq: "Vcto débito fim",
        debito_vencido: "Débito vencido",
        updated_at_gteq: "Alteração início",
        updated_at_lteq: "Alteração fim",
        regularizar_em_vencimento: "Prazo regularizar",
        situacao_id_eq: this.$options.filters.tModel("doc.situacao"),
        comentario_situacao_id_eq: this.$options.filters.tModel(
          "doc.comentario_situacao",
        ),
        existe_senha_web_eq: this.$options.filters.tModel(
          "doc.existe_senha_web",
        ),
        fiscal_id_eq: "Fiscal",
        cadastro_zona_eq: "Zona",
        cadastro_quadra_eq: "Quadra",
        cadastro_lote_eq: "Lote",
        reincidente_eq: "Reincidência",
        ano_eq: "Ano",
        tipo_eq: "Tipo de documento",
        tipo_entrega_eq: this.$options.filters.tModel("doc.tipo_entrega"),
        fiscal_usuario_grupo_id_in: "Grupos de usuário",
        irregularidades_descricao_cont: "Descrição da irregularidade",
      },
      q: {},
      defaultEnabledFilters: ["created_at_gteq", "created_at_lteq"],
      tmpDebitoVencido: "*-*",
      tmpRegularizarEmVencimento: "",
    }
  },

  computed: {
    regularizar_em_vencimento: {
      get() {
        return this.tmpRegularizarEmVencimento
      },
      set(value) {
        this.tmpRegularizarEmVencimento = value
        this.$set(
          this.q,
          "regularizar_em_lt",
          value === "vencido" ? "now" : undefined,
        )
        this.$set(
          this.q,
          "regularizar_em_gt",
          value === "a_vencer" ? "now" : undefined,
        )
      },
    },
    debitoVencido: {
      get() {
        return this.tmpDebitoVencido
      },
      set(v) {
        this.tmpDebitoVencido = v
        const [de, ate] = v.split("-")
        const lteq = this.subDate(de)
        const gteq = this.subDate(ate)
        this.$set(this.q, "debito_vence_em_gteq", gteq)
        this.$set(this.q, "debito_vence_em_lteq", lteq)
      },
    },
  },

  methods: {
    subDate(days) {
      if (days === "*") return null
      const d = new Date()
      const date = new Date(
        d.getFullYear(),
        d.getMonth(),
        d.getDate() - Number(days),
        0,
        0,
        0,
        0,
      )

      return date.toJSON()
    },

    onFilter() {
      this.$emit("submit", this.q)
    },
  },
  created() {
    if (this.initializePeriodo) {
      this.q = {
        created_at_gteq: this.subDate(30),
        created_at_lteq: new Date(
          new Date().setUTCHours(23, 59, 59, 999),
        ).toJSON(),
      }
      this.onFilter()
    }
  },
}
</script>

<style lang="stylus" scoped>
.mx-datepicker {
  padding: 0;
}
</style>
